module.exports = __webpack_public_path__ + "static/img/9.eeaf6ff.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/5/zh/9.png
// module id = RndZ
// module chunks = 0